const STAR_LAYER_NAMES = ["Vector", "Vector 2", "Vector 3"];
const TWINKLE_CYCLE_MS = 2200;
const STAR_DELAYS_MS = [0, 700, 1450];

function getTwinkleOpacity(phase) {
  const t = phase % 1;
  if (t <= 0.18) return 1;
  if (t <= 0.42) {
    const p = (t - 0.18) / 0.24;
    return 1 - p * 0.92;
  }
  if (t <= 0.62) {
    const p = (t - 0.42) / 0.2;
    return 0.08 + p * 0.87;
  }
  const p = (t - 0.62) / 0.38;
  return 0.95 + p * 0.05;
}

function findStarElements(animationItem) {
  const elements = animationItem?.renderer?.elements;
  if (!elements?.length) return [];

  return STAR_LAYER_NAMES.map((name) =>
    elements.find((element) => element?.data?.nm === name)
  ).filter(Boolean);
}

function setStarOpacity(starElement, opacity) {
  const element = starElement.baseElement || starElement.layerElement;
  if (element) {
    element.style.opacity = String(opacity);
  }
}

export function startLottieStarTwinkle(animationItem) {
  const stars = findStarElements(animationItem);
  if (!stars.length) return () => {};

  let rafId = 0;
  const startTime = performance.now();

  const tick = (now) => {
    const elapsed = now - startTime;
    stars.forEach((star, index) => {
      const delay = STAR_DELAYS_MS[index] ?? 0;
      const phase = ((elapsed + delay) % TWINKLE_CYCLE_MS) / TWINKLE_CYCLE_MS;
      setStarOpacity(star, getTwinkleOpacity(phase));
    });
    rafId = requestAnimationFrame(tick);
  };

  rafId = requestAnimationFrame(tick);

  return () => {
    cancelAnimationFrame(rafId);
    stars.forEach((star) => setStarOpacity(star, 1));
  };
}
